import React from "react";

export function SectionCard({ icon, title, subtitle, children, testId }) {
  return (
    <section
      data-testid={testId}
      className="bg-white border border-slate-200/70 rounded-2xl p-6 md:p-8 mb-6 shadow-[0_2px_20px_-8px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-8px_rgba(0,0,0,0.08)] transition-shadow duration-300 hf-fade-up"
    >
      <header className="flex items-start gap-4 mb-7 pb-6 border-b border-slate-100">
        <div className="w-12 h-12 flex items-center justify-center bg-blue-50 text-blue-700 rounded-xl shrink-0">
          {icon}
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-extrabold tracking-tight text-slate-900">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-slate-500 mt-1 font-medium">{subtitle}</p>
          )}
        </div>
      </header>
      {children}
    </section>
  );
}

export function Field({ label, required, error, children, className = "" }) {
  return (
    <div className={className}>
      <label className={`hf-label ${required ? "hf-required" : ""}`}>{label}</label>
      {children}
      {error && (
        <p className="text-xs text-red-600 font-semibold mt-2" data-testid="field-error">
          {error}
        </p>
      )}
    </div>
  );
}
